import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "../../components/main/slider/slider.css";
import { ABOUT_PAGE } from "../../data/texts";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const CommentBox = () => {
  const comments = ABOUT_PAGE.comments;

  return (
    <div className="justify-end items-end -pt-10">
      <Swiper
        className="rounded-3xl"
        modules={[Navigation]}
        slidesPerView={1}
        loop={true}
        navigation={{
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        }}
      >
        {comments.map((e, index) => (
          <SwiperSlide key={index} className="rounded-3xl">
            <div className=" min-h-[220px] flex flex-col  justify-center
            bg-aqua text-white rounded-[15px] p-5 ">
              <p className="border-b border-b-[#ffffff56] pb-4 mb-4 text-justify">
                {e.cm}
              </p>
              <div className="flex justify-between items-center gap-4">
                {/* دکمه‌های ناوبری جایگزین */}

                <div className="flex items-center gap-2">
                  <img
                    src={e.img}
                    className="rounded-full object-cover w-[50px] h-[50px]"
                    alt="user"
                  />
                  <div className="w-9/12">
                    <p className="text-[15px]">{e.name}</p>
                    <p className="text-[12px]">{e.title}</p>
                  </div>
                </div>

                <div className="flex gap-[6px] justify-end items-end">
                  <button className="custom-next w-[30px] h-[30px] rounded-full bg-white text-[#49D1CD] flex items-center justify-center">
                    <IoChevronForward size={18} />
                  </button>
                  <button className="custom-prev w-[30px] h-[30px] rounded-full bg-white text-[#49D1CD] flex items-center justify-center">
                    <IoChevronBack size={18} />
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
export default CommentBox;
